import { useMutation } from '@tanstack/vue-query'
import { useAuthStore } from '@/entities/auth/store'
import { useAppAxios } from '@/app/providers/axios/useAppAxios.ts'
import type { TokenRequest, TokenResponse } from '@/shared/type'
import type { AxiosResponse } from 'axios'

export const useAuthService = () => {
  const appAxios = useAppAxios()
  const globalAuthStore = useAuthStore()

  const login = useMutation({
    mutationFn: async (credentials: { login: string; password: string }) =>
      appAxios.post<TokenResponse, AxiosResponse<TokenResponse>, TokenRequest>(
        '/auth/login',
        {
          login: credentials.login,
          password: credentials.password,
        },
        { withCredentials: true }, // Don't delete
      ),
    onSuccess: (data) => globalAuthStore.setAccessToken(data.data.accessToken),
  })

  const logout = useMutation({
    mutationFn: async () =>
      appAxios.get('/auth/logout', {
        headers: { Authorization: `Bearer ${globalAuthStore.getAccessToken()}` },
        withCredentials: true,
      }),
    onSuccess: () => globalAuthStore.clearTokens(),
    onError: () => globalAuthStore.clearTokens(),
  })

  const refresh = useMutation({
    mutationFn: async () => appAxios.get<TokenResponse>('/auth/refresh', { withCredentials: true }),
    onSuccess: (data) => globalAuthStore.setAccessToken(data.data.accessToken),
    onError: () => globalAuthStore.clearTokens(),
  })

  return { login, logout, refresh }
}
